import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=7321d448&scoped=true"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"
import style0 from "./Component.vue?vue&type=style&index=0&id=7321d448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7321d448",
  null
  
)

export default component.exports